/**
 * Accès du HUD au store et au moteur, et envoi des commandes avec retour
 * visuel (toast en cas de refus du serveur).
 */
import type { Command } from '@snowchain/shared';
import type { ClientStore } from '../state/store';
import type { Engine } from '../render/engine';
import { toast, ui } from './ui-state';

export const hud: { store: ClientStore | null; engine: Engine | null; logout: () => void; claim: () => void } = {
  store: null,
  engine: null,
  logout: () => undefined,
  claim: () => undefined,
};

export async function command(cmd: Command, okMessage?: string): Promise<boolean> {
  const store = hud.store;
  if (!store) return false;
  const ack = await store.sendCommand(cmd);
  if (!ack.ok) toast('danger', 'Action refusée', ack.error);
  else if (okMessage) toast('ok', okMessage);
  return ack.ok;
}

/** Centre la caméra sur une entité et la sélectionne. */
export function focusEntity(kind: 'lift' | 'piste' | 'building', id: number): void {
  const store = hud.store;
  const engine = hud.engine;
  const r = store?.replica;
  if (!store || !engine || !r) return;
  if (kind === 'lift') {
    const l = r.lifts.get(id);
    if (l) engine.cam.focus((l.bottom[0] + l.top[0]) / 2, (l.bottom[1] + l.top[1]) / 2, 900);
  } else if (kind === 'piste') {
    const p = r.pistes.get(id);
    const mid = p?.path[Math.floor(p.path.length / 2)];
    if (mid) engine.cam.focus(mid[0], mid[1], 800);
  } else {
    const b = r.buildings.get(id);
    if (b) engine.cam.focus(b.x, b.z, 220);
  }
  ui.selection.value = { kind, id };
}
